import Button from '@material-ui/core/Button';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente ModalBox
 */
export const ModalBox = styled.div`
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  padding: 35px;
  box-sizing: border-box;
  outline: 0;
  padding-top: 26px;
  padding-bottom: 40px;
  width: 387px;
  min-width: 320px;
  max-width: 80vw;
  height: 228px;

  header {
    padding-bottom: 12px;
    border-bottom: 1px solid #E6E6E6;
    h2 {
      font-family: 'Roboto';
      font-size: 16px;
      font-weight: 300;
      line-height: 18.75px;
      color: #5E6366;
    }
  }

  .content{
    margin: 25px 0 35px 0;
    padding: 0 8px;
    p{
      margin: 0 0 0 0;
      font-family: 'Roboto';
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      color: #5E6366;
    }
  }

  footer {    
    .dont-show-again {
      p{      
        display:inline:
      }
      .mensage{
        display:inline:
      }
      display:inline:
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #5e6366;
    }
    .button{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .close {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
  }
`;

/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  &.MuiButton-root {
    text-transform: none;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    padding: 8px 20px;
    width: 101px;
    height: 32.6px;
    border-radius: 3px;
  }

  &.MuiButton-contained {
    box-shadow: none;
  }

  &.MuiButton-containedPrimary {
    color: #fff;
    background-color: #3C71DD;
  }

  &.MuiButton-containedSecondary {
    color: #fff;
    background-color: #aeaeae;

    &:hover {
      background-color: #a8a8a8;
    }
  }
`;
